(() => {
  if (document.getElementsByClassName("custom__select")) {
    var e, t, s, n, l, a, c, i, d;
    for (
      n = (e = document.getElementsByClassName("custom__select")).length, t = 0;
      t < n;
      t++
    ) {
      for (
        l = (a = e[t].getElementsByTagName("select")[0]).length,
          (c = document.createElement("DIV")).setAttribute(
            "class",
            "select-selected"
          ),
          c.innerHTML = a.options[a.selectedIndex].innerHTML,
          c.classList.add("placeholder"),
          e[t].appendChild(c),
          (i = document.createElement("DIV")).setAttribute(
            "class",
            "select-items select-hide"
          ),
          s = 1;
        s < l;
        s++
      )
        ((d = document.createElement("DIV")).innerHTML =
          a.options[s].innerHTML),
          d.addEventListener("click", function (e) {
            const t =
              this.parentNode.parentNode.getElementsByTagName("select")[0];
            var s, n, l, a, i, d, o;
            for (
              c.classList.remove("placeholder"),
                d = (a =
                  this.parentNode.parentNode.getElementsByTagName("select")[0])
                  .length,
                i = this.parentNode.previousSibling,
                n = 0;
              n < d;
              n++
            )
              if (a.options[n].innerHTML == this.innerHTML) {
                for (
                  a.selectedIndex = n,
                    i.innerHTML = this.innerHTML,
                    o = (s =
                      this.parentNode.getElementsByClassName(
                        "same-as-selected"
                      )).length,
                    l = 0;
                  l < o;
                  l++
                )
                  s[l].removeAttribute("class");
                this.setAttribute("class", "same-as-selected");
                break;
              }
            i.click(), t.dispatchEvent(new Event("change"));
          }),
          i.appendChild(d);
      e[t].appendChild(i),
        c.addEventListener("click", function (e) {
          e.stopPropagation(),
            o(this),
            this.nextSibling.classList.toggle("select-hide"),
            this.classList.toggle("select-arrow-active");
        });
    }
    function o(e) {
      var t,
        s,
        n,
        l,
        a,
        c = [];
      for (
        t = document.getElementsByClassName("select-items"),
          s = document.getElementsByClassName("select-selected"),
          l = t.length,
          a = s.length,
          n = 0;
        n < a;
        n++
      )
        e == s[n] ? c.push(n) : s[n].classList.remove("select-arrow-active");
      for (n = 0; n < l; n++) c.indexOf(n) && t[n].classList.add("select-hide");
    }
    document.addEventListener("click", o);
  }
})();
